import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { I18nProvider } from "./contexts/I18nContext";
import Onboarding from "./components/Onboarding";
import Feed from "./components/Feed";
import Directory from "./components/Directory";
import ProfileEdit from "./components/ProfileEdit";
import Encounters from "./components/Encounters";
import Places from "./components/Places";
import Messages from "./components/Messages";
import Blog from "./components/Blog";
import Premium from "./components/Premium";
import ProfileVisitors from "./components/ProfileVisitors";
import ProDashboard from "./components/ProDashboard";
import PlacePublic from "./components/PlacePublic";
import StaticPage from "./components/StaticPage";
import Layout from "./components/Layout";
import LayoutPublic from "./components/LayoutPublic";
import AdminDashboard from "./components/AdminDashboard";

// Wrapper pour passer user à Blog depuis le contexte Auth
function BlogWithUser() {
  const { user } = useAuth();
  return <Blog user={user} />;
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-sensoria-bg">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-sensoria-accent border-t-transparent" />
      </div>
    );
  }
  return user ? children : <Navigate to="/welcome" replace />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-sensoria-bg">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-sensoria-accent border-t-transparent" />
      </div>
    );
  }
  return user ? <Navigate to="/" replace /> : children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/welcome" element={<PublicRoute><Onboarding /></PublicRoute>} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Feed />} />
        <Route path="directory" element={<Directory />} />
        <Route path="encounters" element={<Encounters />} />
        <Route path="places" element={<Places />} />
        <Route path="messages" element={<Messages />} />
        <Route path="messages/:partnerId" element={<Messages />} />
        <Route path="blog" element={<BlogWithUser />} />
        <Route path="blog/:slug" element={<BlogWithUser />} />
        <Route path="premium" element={<Premium />} />
        <Route path="visitors" element={<ProfileVisitors />} />
        <Route path="pro" element={<ProDashboard />} />
        <Route path="profile" element={<ProfileEdit />} />
      </Route>
      {/* Public SEO page (no auth required) */}
      <Route path="/lieux/:slug" element={<PlacePublic />} />
      {/* Pages statiques — avec header/footer commun */}
      <Route element={<LayoutPublic />}>
        <Route path="/p/:slug" element={<StaticPage />} />
        <Route path="/a-propos" element={<StaticPage />} />
        <Route path="/comment-ca-marche" element={<StaticPage />} />
        <Route path="/securite-confidentialite" element={<StaticPage />} />
        <Route path="/annuaire-clubs-libertins-france" element={<StaticPage />} />
        <Route path="/rencontres-libertines" element={<StaticPage />} />
        <Route path="/tarifs" element={<StaticPage />} />
        <Route path="/contact" element={<StaticPage />} />
        <Route path="/mentions-legales" element={<StaticPage />} />
        <Route path="/politique-de-confidentialite" element={<StaticPage />} />
        <Route path="/conditions-generales-utilisation" element={<StaticPage />} />
        <Route path="/charte-communautaire" element={<StaticPage />} />
      </Route>
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </I18nProvider>
  );
}
